import Vue from 'vue'
import VueRouter from 'vue-router';
import router from './router/router';
import ElementUI from 'element-ui';
import '@/assets/js/axios/http_axios'
import 'element-ui/lib/theme-chalk/index.css';
import common from '@/assets/js/comm.js'
import App from './App.vue'
import 'default-passive-events'
import Print from '@/assets/js/common/print.js'
import Tools from '@/assets/js/tool.js'
import Api from '@/assets/js/API/api.js'
import comAPI from '@/assets/js/comAPI.js'
import '@/assets/css/base.less'
import directives from '@/assets/js/directives/directives'
import {
  showLoading,
  hideLoading
} from '@/assets/js/common/loading'

// element弹出框拖动指令
import '@/assets/js/directives/dialog.js';
// 自定义打印系统需要
import { hiPrintPlugin } from './print.js';

import store from './store';

ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Print);
Vue.use(directives)
Vue.use(hiPrintPlugin)


// 自定义打印系统需要
import Storage from 'vue-ls'
let options = {
  namespace: 'hiPrint-',
  name: 'ls',
  storage: 'local',
};
Vue.use(Storage, options);

function hasBtnPermission(permission) {
  let PermissionArr = JSON.parse(sessionStorage.getItem('btnPermiss')) || [];
  PermissionArr.push('aaaaa')
  let flga = false
  PermissionArr.forEach(item => {
    if (item === permission) {
      flga = true
    }
  });
  //测试的时候全部有权限
  if (common.isTest) {
    flga = true
  }
  return flga
  // return PermissionArr.indexOf(permission) > -1
}
Vue.prototype.hasPermiss = hasBtnPermission
Vue.prototype.$COMMON = common;
Vue.prototype.$API = Api;
Vue.prototype.$TOOLS = Tools;
Vue.prototype.$COMAPI = comAPI;
Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;


// 对象类型检测
Vue.prototype.$getObject = function (v) {
  let s = Object.prototype.toString.call(v);
  if (s == '[object Object]') {
    return 'Object'
  } else if (s == '[object Null]') {
    return 'Null'
  } else if (s == '[object Number]') {
    return 'Number'
  } else if (s == '[object Boolean]') {
    return 'Boolean'
  } else if (s == '[object String]') {
    return 'String'
  } else if (s == '[object Array]') {
    return 'Array'
  } else if (s == '[object Date]') {
    return 'Date'
  } else if (s == '[object Function]') {
    return 'Function'
  } else if (s == '[object Undefined]') {
    return 'Undefined'
  } else {
    return s;
  }
}














Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app')
Vue.prototype.$keyBoard = function (vm, methodName, code) {
  document.onkeydown = function () {
    let key = window.event.keyCode;
    if (key == code) {
      vm[methodName](code); // 触发methodName事件
    }
  };
}
